import { HistoryGuard } from './history.guard';

export const guards: any[] = [HistoryGuard];

export * from './history.guard';
